import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class WindowService {
	constructor() {
	}

	getNativeWindow() {
		return window;
	}

	openWindowWithToken(url: string, target: string) {
		window.open(this.ajouterToken(url), target);
	}

	private ajouterToken(url: string) {
		const token = 'access_token=' + localStorage.getItem('access_token');
		const characterJoin = url.indexOf('?') === -1 ? '?' : '&';
		return [url, token].join(characterJoin);
	}

	/**
	 * Méthode qui permet de faire une attente active pendant le délai indiqué en paramètre.
	 *
	 * @param ms le délai en millisecondes
	 */
	dormir(ms: number) {
		const e = Date.now() + (ms);
		while (Date.now() <= e) {
		}
	}
}
